import { View } from 'react-native';
import styled from 'styled-components/native';

export const Panel = styled(View)`
  background-color: white;
  border-radius: 20px;
  elevation: 4;
`;
